<div class="push-main-wrapper">
    <div class="push-header">
        <h1>📲 Envío de Notificaciones Push y Mensajes Internos</h1>
        <p>Gestioná y enviá comunicaciones directas (Alertas Push + Centro de Notificaciones App) a los afiliados.</p>
    </div>

    <div class="steps-container">
        <!-- ================= PASO 1: MENSAJE ================= -->
        <section class="step-column step-message-col">
            <div class="step-card step-message">
                <div class="step-header">
                    <div class="step-badge">1</div>
                    <div class="step-info">
                        <h2>Configurá el Mensaje</h2>
                        <p>Definí el contenido visual de la notificación</p>
                    </div>
                </div>

                <div class="message-builder">
                    <!-- TÍTULO -->
                    <div class="field-group">
                        <div class="format-toolbar">
                            <span class="toolbar-label">Insertar en título:</span>
                            <div class="emoji-picker">
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('📢 ')">📢</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('⚠️ ')">⚠️</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('✅ ')">✅</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('🔥 ')">🔥</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('📍 ')">📍</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoTitle('🕒 ')">🕒</button>
                            </div>
                            <button mat-icon-button (click)="clearTitle()" matTooltip="Borrar título" class="clear-btn">
                                <mat-icon>delete_sweep</mat-icon>
                            </button>
                        </div>
                        <mat-form-field appearance="outline" class="full-width custom-field">
                            <mat-label>Título de la notificación</mat-label>
                            <input #titleInput matInput [(ngModel)]="title" placeholder="Ej: Importante actualización" />
                        </mat-form-field>
                    </div>

                    <!-- MENSAJE -->
                    <div class="field-group">
                        <div class="format-toolbar">
                            <span class="toolbar-label">Insertar en mensaje:</span>
                            <div class="emoji-picker">
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('📢 ')">📢</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('⚠️ ')">⚠️</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('✅ ')">✅</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('🔥 ')">🔥</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('📍 ')">📍</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('🕒 ')">🕒</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('• ')">•</button>
                                <button mat-button class="emoji-btn" (click)="insertIntoBody('\n')">↩︎</button>
                            </div>
                            <button mat-icon-button (click)="clearBody()" matTooltip="Borrar mensaje" class="clear-btn">
                                <mat-icon>delete_sweep</mat-icon>
                            </button>
                        </div>
                        <mat-form-field appearance="outline" class="full-width custom-field">
                            <mat-label>Cuerpo del mensaje</mat-label>
                            <textarea #bodyInput matInput rows="6" [(ngModel)]="body" placeholder="Escribí el contenido aquí..."></textarea>
                        </mat-form-field>
                    </div>

                    <!-- Info Box sobre la duración de los mensajes -->
                    <div class="info-legend-box">
                        <mat-icon class="info-icon">info</mat-icon>
                        <p class="info-text">
                            <strong>Comportamiento en la App:</strong> Las notificaciones recibidas en los celulares de los afiliados tienen una vigencia de <strong>36 horas</strong> en su bandeja de entrada (caché local). Pasado ese tiempo, o al superar un límite de <strong>50 mensajes</strong>, se depuran automáticamente.
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <!-- ================= PASO 2: DESTINATARIOS ================= -->
        <section class="step-column step-target-col">
            <div class="step-card step-target">
                <div class="step-header">
                    <div class="step-badge">2</div>
                    <div class="step-info">
                        <h2>Seleccioná Destinatarios</h2>
                        <p>Elegí a quién llegará esta notificación</p>
                    </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="custom-tabs">
                    <!-- POR TOKEN -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="mr-2">code</mat-icon> Token
                        </ng-template>
                        <div class="tab-padding">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Token del dispositivo (FCM)</mat-label>
                                <textarea matInput rows="3" [(ngModel)]="token" placeholder="Pegá el token único del dispositivo..."></textarea>
                            </mat-form-field>
                            <div class="actions-footer">
                                <button mat-flat-button color="primary" class="btn-send-main" (click)="enviarPorToken()" [disabled]="loading || loadingSending || !token">
                                    <mat-icon>send</mat-icon> Enviar por Token
                                </button>
                            </div>
                        </div>
                    </mat-tab>

                    <!-- BUSCAR USUARIO -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="mr-2">person_search</mat-icon> Usuario
                        </ng-template>
                        <div class="tab-padding">
                            <mat-form-field appearance="outline" class="full-width search-box">
                                <mat-label>Buscar por nombre, email o DNI</mat-label>
                                <input matInput [(ngModel)]="searchTerm" (keyup.enter)="buscarUsuarios()" />
                                <button mat-icon-button matSuffix (click)="buscarUsuarios()" [disabled]="loadingSearchUser">
                                    <mat-icon>search</mat-icon>
                                </button>
                            </mat-form-field>

                            <div class="user-loading-box mt-2 mb-2" *ngIf="loadingSearchUser" style="padding: 16px; text-align: center;">
                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                <span style="font-size: 0.85rem; color: #666; display: block; margin-top: 8px; font-weight: 500;">
                                    Buscando afiliados en la base de datos...
                                </span>
                            </div>

                            <div class="results-container" *ngIf="usuarios.length && !loadingSearchUser">
                                <div class="table-scroll">
                                    <table mat-table [dataSource]="usuarios" class="full-width custom-table">
                                        <ng-container matColumnDef="nombre">
                                            <th mat-header-cell *matHeaderCellDef>Nombre</th>
                                            <td mat-cell *matCellDef="let u">{{ u.nombrePersona }} {{ u.apellidoPersona }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="email">
                                            <th mat-header-cell *matHeaderCellDef>Email</th>
                                            <td mat-cell *matCellDef="let u" class="email-cell">{{ u.email }}</td>
                                        </ng-container>

                                        <ng-container matColumnDef="accion">
                                            <th mat-header-cell *matHeaderCellDef></th>
                                            <td mat-cell *matCellDef="let u" class="action-cell">
                                                <button mat-icon-button [color]="u.pushToken ? 'primary' : 'accent'" (click)="enviarAUsuario(u)" [disabled]="loadingSending" [matTooltip]="u.pushToken ? 'Enviar Push + Mensaje Interno' : 'Enviar solo Mensaje Interno (Usuario sin token)'">
                                                    <mat-icon>{{ u.pushToken ? 'send' : 'mail' }}</mat-icon>
                                                </button>
                                            </td>
                                        </ng-container>

                                        <tr mat-header-row *matHeaderRowDef="cols"></tr>
                                        <tr mat-row *matRowDef="let row; columns: cols"></tr>
                                    </table>
                                </div>
                            </div>
                            <div class="no-results" *ngIf="!usuarios.length && searchTerm.length > 2 && !loadingSearchUser">
                                <mat-icon>info_outline</mat-icon> No se encontraron usuarios con ese criterio.
                            </div>
                        </div>
                    </mat-tab>

                    <!-- POR PLAN -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="mr-2">groups</mat-icon> Plan
                        </ng-template>
                        <div class="tab-padding">
                            <mat-form-field appearance="outline" class="full-width">
                                <mat-label>Seleccioná el Plan Médico</mat-label>
                                <mat-select [(ngModel)]="planSeleccionado" (selectionChange)="buscarUsuariosPorPlan()" [disabled]="loading || loadingSending">
                                    <mat-option *ngFor="let p of planes" [value]="p._id">{{ p.denominacion }}</mat-option>
                                </mat-select>
                            </mat-form-field>

                            <div class="plan-loading" *ngIf="loading && planSeleccionado" style="padding: 24px; text-align: center;">
                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                <span style="font-size: 0.88rem; color: #495057; display: block; margin-top: 10px; font-weight: 500;">
                                    Calculando audiencia y cargando afiliados del plan...
                                </span>
                            </div>

                            <div class="plan-data" *ngIf="totalPlan > 0 && !loading">
                                <div class="metrics-grid">
                                    <div class="metric-card" (click)="verDestinatariosPlan('todos')" style="cursor: pointer;" matTooltip="Click para ver el listado de afiliados">
                                        <span class="m-label">Afiliados</span>
                                        <span class="m-value">{{ totalPlan }}</span>
                                    </div>
                                    <div class="metric-card highlight" (click)="verDestinatariosPlan('push')" style="cursor: pointer;" matTooltip="Click para ver afiliados habilitados con Push">
                                        <span class="m-label">Habilitados</span>
                                        <span class="m-value">{{ totalConPush }}</span>
                                    </div>
                                    <div class="metric-card os" (click)="verDestinatariosPlan('ios')" style="cursor: pointer;" matTooltip="Click para ver afiliados con iOS">
                                        <span class="m-label">iOS</span>
                                        <span class="m-value">{{ totalIOS }}</span>
                                    </div>
                                    <div class="metric-card os" (click)="verDestinatariosPlan('android')" style="cursor: pointer;" matTooltip="Click para ver afiliados con Android">
                                        <span class="m-label">Android</span>
                                        <span class="m-value">{{ totalAndroid }}</span>
                                    </div>
                                </div>

                                <!-- Resumen de Destinatarios (Plan) -->
                                <div class="audience-summary-box mt-3" style="background-color: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 15px; margin-bottom: 15px;">
                                    <h4 style="margin: 0 0 10px 0; font-size: 0.95rem; color: #495057; font-weight: 600; display: flex; align-items: center; gap: 6px;">
                                        <mat-icon style="font-size: 1.1rem; width: auto; height: auto;">analytics</mat-icon>
                                        Resumen de Envío (Centro de Notificaciones)
                                    </h4>
                                    <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 15px;">
                                        <div>
                                            <p style="margin: 4px 0; font-size: 0.85rem; color: #495057;">
                                                <strong>Afiliados totales:</strong> {{ totalPlan }}
                                            </p>
                                            <p style="margin: 4px 0; font-size: 0.85rem; color: #2e7d32;">
                                                <strong>Con token Push:</strong> {{ totalConPush }}
                                            </p>
                                            <p style="margin: 4px 0; font-size: 0.85rem; color: #c62828;">
                                                <strong>Sin token Push:</strong> {{ totalPlan - totalConPush }}
                                            </p>
                                        </div>
                                        <div style="border-left: 1px solid #dee2e6; padding-left: 15px;">
                                            <p style="margin: 4px 0; font-size: 0.85rem; color: #1565c0;">
                                                <strong>Push a enviar:</strong> {{ totalConPush }}
                                            </p>
                                            <p style="margin: 4px 0; font-size: 0.85rem; color: #ef6c00;">
                                                <strong>Mensajes internos:</strong> {{ totalPlan }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <mat-form-field appearance="outline" class="full-width mt-3">
                                    <mat-icon matPrefix>filter_list</mat-icon>
                                    <input matInput [(ngModel)]="filtroPlan" (ngModelChange)="aplicarFiltroPlan($event)" placeholder="Filtrar por nombre..." />
                                </mat-form-field>

                                <div class="actions-footer mt-2">
                                    <button mat-flat-button color="warn" class="btn-massive-action" (click)="enviarPushPorPlan()" [disabled]="loading || loadingSending || totalPlan === 0">
                                        <mat-icon>campaign</mat-icon> Notificar a {{ totalPlan }} afiliados
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                    <!-- A TODOS -->
                    <mat-tab>
                        <ng-template mat-tab-label>
                            <mat-icon class="mr-2">public</mat-icon> Masivo
                        </ng-template>
                        <div class="tab-padding center">
                            <div class="warn-banner">
                                <mat-icon>warning</mat-icon>
                                <div>
                                    <strong>¡Atención!</strong>
                                    <p>Esta comunicación se enviará a <strong>todos los usuarios activos</strong>. Recibirán un <strong>mensaje interno</strong> en su bandeja de la App, y quienes tengan la App instalada con notificaciones habilitadas recibirán además la <strong>alerta Push</strong>.</p>
                                </div>
                            </div>

                            <!-- Resumen de Destinatarios (Masivo) -->
                            <div class="audience-summary-box mt-3 mb-3" style="text-align: left; background-color: #f8f9fa; border: 1px solid #e9ecef; border-radius: 6px; padding: 15px; width: 100%; max-width: 480px; margin: 0 auto 15px auto;">
                                <h4 style="margin: 0 0 10px 0; font-size: 0.95rem; color: #495057; font-weight: 600; display: flex; align-items: center; gap: 6px;">
                                    <mat-icon style="font-size: 1.1rem; width: auto; height: auto;">analytics</mat-icon>
                                    Resumen de Envíos Masivos (Base Total de Usuarios)
                                </h4>
                                <div *ngIf="loadingMasivo" style="display: flex; align-items: center; gap: 8px; font-size: 0.85rem; color: #666; padding: 10px 0;">
                                    <mat-spinner diameter="20"></mat-spinner>
                                    <span>Calculando total de afiliados en base de datos...</span>
                                </div>
                                <div *ngIf="!loadingMasivo">
                                    <p style="margin: 4px 0; font-size: 0.85rem; color: #495057;">
                                        <strong>Afiliados totales en base de datos:</strong> {{ totalMasivo }}
                                    </p>
                                    <p style="margin: 4px 0; font-size: 0.85rem; color: #2e7d32;">
                                        <strong>Con token Push (Reciben Notificación Push):</strong> {{ totalConPushMasivo }}
                                    </p>
                                    <p style="margin: 4px 0; font-size: 0.85rem; color: #c62828;">
                                        <strong>Sin token Push (Reciben Mensaje Interno):</strong> {{ totalSinPushMasivo }}
                                    </p>
                                    <p style="margin: 4px 0; font-size: 0.85rem; color: #1565c0; margin-top: 8px; border-top: 1px dashed #ccc; padding-top: 6px;">
                                        <strong>Total Mensajes Internos a depositar:</strong> {{ totalMasivo }}
                                    </p>
                                </div>
                            </div>

                            <button mat-flat-button color="warn" class="btn-massive-action" (click)="enviarATodos()" [disabled]="loading || loadingSending || loadingMasivo || totalMasivo === 0">
                                <mat-icon>campaign</mat-icon> Notificar a {{ totalMasivo }} afiliados (Masivo)
                            </button>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </section>
    </div>
</div>

<!-- ================= OVERLAY DE PROCESAMIENTO / ENVÍO ================= -->
<div class="global-sending-overlay" *ngIf="loadingSending">
    <div class="overlay-card">
        <!-- Spinner si no hay total conocido, o Porcentaje dinámico -->
        <mat-spinner diameter="52" color="primary" *ngIf="sendingTotal === 0"></mat-spinner>
        <div class="progress-circle-badge" *ngIf="sendingTotal > 0">
            <span class="progress-number">{{ sendingProgress }}%</span>
        </div>

        <h3>Procesando Comunicación...</h3>
        <p>{{ loadingSendingText || 'Enviando notificaciones Push y registrando mensajes en la App. Esto puede demorar unos segundos...' }}</p>

        <!-- Indicador de avance procesados / total -->
        <div class="sending-counter-info" *ngIf="sendingTotal > 0">
            <span>Enviando: <strong>{{ sendingProcessed | number }}</strong> de <strong>{{ sendingTotal | number }}</strong> afiliados</span>
        </div>

        <div class="sending-progress-bar">
            <mat-progress-bar
                [mode]="sendingTotal > 0 ? 'determinate' : 'indeterminate'"
                [value]="sendingProgress">
            </mat-progress-bar>
        </div>
        <span class="warning-subtext">Por favor, mantenga abierta esta pantalla hasta finalizar el proceso.</span>
    </div>
</div>

